import { SvgIcon, SvgIconProps } from "@mui/material";

export const RMMFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M24.5 16.333v.584a3.5 3.5 0 0 1-3.5 3.5H7a3.5 3.5 0 0 1-3.5-3.5V7A3.5 3.5 0 0 1 7 3.5h3.5"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M24.5 16.333v.584a3.5 3.5 0 0 1-3.5 3.5H7a3.5 3.5 0 0 1-3.5-3.5V7A3.5 3.5 0 0 1 7 3.5h3.5"
      />
      <rect
        width="11.667"
        height="10.5"
        x="25.675"
        y="12.837"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        rx="2"
        transform="rotate(-180 25.675 12.837)"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M9.325 24.496h9.334M16.625 20.413l.292 4.084M11.367 20.413l-.292 4.084"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="m22.165 9.923-.006.006-.006-.006.006-.005.006.005Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M25.667 10.5V9.333A2.333 2.333 0 0 0 23.333 7h-7A2.333 2.333 0 0 0 14 9.333V10.5"
      />
    </svg>
  </SvgIcon>
);
